import AnalyticsEvent from './analytics-event';
import { Product, Wishlist } from './segment-ecommerce-types';

export class ProductAddedToWishlistEvent extends AnalyticsEvent {
  public readonly name = 'Product Added to Wishlist';

  constructor(public readonly properties: Wishlist & Product) {
    super();
  }
}
